export default __webpack_public_path__ + "static/media/gif pantalone.2b84d333.gif";